export const REFRESH_TOKEN_ENDPOINT = 'user/refreshToken';
export const RESIZED_IMAGE_ENDPOINT = 'file/Images';
export const TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const NAVBAR_FOLDED = 'navbar_folded';
export const AUTH_TYPE_KEY = 'auth_type';
export const UPLOAD_PATH = 'static-files/file/upload';
export const TEMPORARY_PATH = 'static-files/file/temp';
export const PERMANENT_PATH = 'static-files/permanent';
export const STATIC_DATA = 'static-data';
export const OAUTH2_ID = '228243209475-2vdif5qqqonlvgjivft31c3a41qv4mgs.apps.googleusercontent.com';

export const UsernameType = Object.freeze({
	EMAIL: 1,
	MOBIL: 2
});

export const AuthType = Object.freeze({
	USERNAME_AND_PASSWORD: 1,
	GOOGLE: 2,
	FACEBOOK: 3
});

export const SubSystem = Object.freeze({
	AIAAS: 'aiaas'
});

export const Priority = Object.freeze({
	Low: 1,
	Normal: 2,
	High: 3,
	Critical: 4
});

export const TicketType = Object.freeze({
	ERROR_REPORT: 1,
	FEEDBACK_AND_COMMENT: 2,
	LICENSE: 3,
	OTHERS: 4
});

export const TicketStatus = Object.freeze({
	New : 1,
	Assigned : 2,
	'In Progress' : 3,
	Pending : 4,
	Resolved : 5,
});

export const TicketCategories = [
	{ subSystem: SubSystem.AIAAS, category: 1, key: 'general', order: 1, value: null },
	{ subSystem: SubSystem.AIAAS, category: 2, key: 'lineSegmentDetector', order: 2, value: 1 },
	{ subSystem: SubSystem.AIAAS, category: 3, key: 'arcLineDetector', order: 3, value: 16 },
	{ subSystem: SubSystem.AIAAS, category: 4, key: 'contrastEnhancement', order: 4, value: 3 },
	{ subSystem: SubSystem.AIAAS, category: 5, key: 'denoising', order: 5, value: 4 },
	{ subSystem: SubSystem.AIAAS, category: 6, key: 'deblurring', order: 6, value: 5 },
	{ subSystem: SubSystem.AIAAS, category: 7, key: 'deraining', order: 7, value: 6 },
	{ subSystem: SubSystem.AIAAS, category: 8, key: 'objectDetection', order: 10, value: 7 },
	{ subSystem: SubSystem.AIAAS, category: 9, key: 'countObjects', order: 13, value: 8 },
	{ subSystem: SubSystem.AIAAS, category: 10, key: 'resolutionEnhancement', order: 8, value: 9 },
	{ subSystem: SubSystem.AIAAS, category: 11, key: 'poseEstimation', order: 11, value: 10 },
	{ subSystem: SubSystem.AIAAS, category: 12, key: 'faceDetection', order: 12, value: 11 },
	{ subSystem: SubSystem.AIAAS, category: 13, key: 'deepLearning', order: 20, value: 30 },
	{ subSystem: SubSystem.AIAAS, category: 14, key: 'classificationAnnotation', order: 19, value: 31 },
	{ subSystem: SubSystem.AIAAS, category: 15, key: 'boundingBoxAnnotation', order: 18, value: 33 },
	{ subSystem: SubSystem.AIAAS, category: 16, key: 'boundaryAnnotation', order: 17, value: 32 },
	{ subSystem: SubSystem.AIAAS, category: 17, key: 'faceRecognition', order: 15, value: 12 },
	{ subSystem: SubSystem.AIAAS, category: 18, key: 'inpainting', order: 9, value: 13 },
	{ subSystem: SubSystem.AIAAS, category: 19, key: 'anomalyDetection', order: 14, value: 15 },
	{ subSystem: SubSystem.AIAAS, category: 20, key: 'correctiveExercise', order: 16, value: 14 }
];

export const FaqCategories = [
	{ subSystem: SubSystem.AIAAS, category: 1, key: 'paymentsBilling' },
	{ subSystem: SubSystem.AIAAS, category: 2, key: 'security' },
	{ subSystem: SubSystem.AIAAS, category: 3, key: 'account' }
];

export const Language = Object.freeze({
	EN: 1
});

export const thumbnailMimeTypes = ['image/bmp', 'image/jpeg', 'image/png', 'image/gif', 'image/svg+xml', 'image/webp'];

export const DurationUnit = Object.freeze({
	MONTHLY: 1
});
